import React, { useState, useEffect } from "react";
import { Popup, PopupTitle, PopupContent, NavPanes } from "@tv2no/ui-react";
import { ImportDetails } from "../../../../../components/import/ImportDetails";
import { ImportLogTable } from "../../../../../components/import/ImportLogTable";
import { getImportEntryLog } from "../../../../../api/services/taxYear";

export const ImportEntry = ({ entry, onClose }) => {
    const [activeKey, setActiveKey] = useState(1);
    const [logList, setLogList] = useState(null);

    useEffect(() => {
        getImportEntryLog(entry.id).then((response) => {
            setLogList(response);
        });
    }, [entry]);

    return (
        <Popup onClose={onClose} size="medium">
            <PopupTitle>Importdetaljer</PopupTitle>
            <NavPanes embedded activeKey={activeKey} onChange={setActiveKey}>
                <NavPanes.Pane paneKey={1} icon="list" label="Detaljer">
                    <PopupContent>
                        <ImportDetails entry={entry} />
                    </PopupContent>
                </NavPanes.Pane>
                <NavPanes.Pane paneKey={2} icon="clock" label="Logg">
                    <PopupContent>
                        <ImportLogTable log={logList} />
                    </PopupContent>
                </NavPanes.Pane>
            </NavPanes>
        </Popup>
    );
};
